var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLocationPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12.0529C3.69857 12.0529 1.42857 7.37173 1.42857 4.68729C1.42857 2.84119 3.03071 1.33926 5 1.33926C6.96929 1.33926 8.57143 2.84119 8.57143 4.68729C8.57143 7.37173 6.30143 12.0529 5 12.0529ZM5 0C2.23857 0 0 2.09854 0 4.68723C0 7.27592 2.23857 13.3921 5 13.3921C7.76143 13.3921 10 7.27592 10 4.68723C10 2.09854 7.76143 0 5 0ZM5 5.78198C4.60643 5.78198 4.28571 5.482 4.28571 5.11238C4.28571 4.74343 4.60643 4.44277 5 4.44277C5.39357 4.44277 5.71428 4.74343 5.71428 5.11238C5.71428 5.482 5.39357 5.78198 5 5.78198ZM5 3.10367C3.81643 3.10367 2.85714 4.00362 2.85714 5.11248C2.85714 6.22201 3.81643 7.12129 5 7.12129C6.18357 7.12129 7.14286 6.22201 7.14286 5.11248C7.14286 4.00362 6.18357 3.10367 5 3.10367Z",
    fill: "#90A8BE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location-pin.c68106fe.svg";
export { ForwardRef as ReactComponent };